import * as React from "react";
import {Loader} from "../../../../components/Utils/loader/Loader";
import {SectionContent, SectionModel, SectionParams} from "../builder/models";
import {EQUIPMENT_PRODUCT_STOCK_GUID, EquipmentSettingsService} from "../EquipmentSettingsService";
import {Section} from "./Section";
import {SectionFormBody} from "./SectionFormBody";

import "./LoadableSection.scss";
import {ProductsStockLevel} from "../../settings/ProductsStockLevel";
import {Display} from "../../../../components/Display";

interface LoadableSectionProps {
    sectionInfo: SectionModel;
    className?: string;
    onLoaded?: (sectionID: string) => void;
    reloadSections?: () => void;
}

interface LoadableSectionState {
    loaded: boolean;
    content?: any;
    isChildHTML: boolean;
    reactComponent?: JSX.Element;
}

export class LoadableSection extends React.Component<LoadableSectionProps, LoadableSectionState> {

    private onFormUpdated: (formData: any) => void;

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            isChildHTML: false,
        };
    }

    public componentDidMount() {
        this.load();
    }

    public componentWillUnmount() {
        this.onFormUpdated = null;
    }

    public render() {
        return (
            <>
                <Display isVisible={!this.state.reactComponent}>
                    <Section
                        className={"LoadableSection" + (this.props.className ? " " + this.props.className : "")}
                        title={this.state.isChildHTML ? undefined : this.props.sectionInfo.name}
                        legacySection={this.state.isChildHTML && this.state.loaded}
                    >
                        {this.state.loaded
                            ? (
                                this.state.isChildHTML
                                    ? (
                                        <div
                                            id={
                                                this.props.sectionInfo.params
                                                    ? this.props.sectionInfo.params.htmlContainerID
                                                    : undefined
                                            }
                                            data-id={
                                                this.props.sectionInfo.params
                                                    ? this.props.sectionInfo.params.htmlContainerID
                                                    : undefined
                                            }
                                            style={{
                                                flexGrow: 1,
                                                padding: 10
                                            }}
                                            dangerouslySetInnerHTML={{__html: this.state.content}}
                                        />
                                    )
                                    : <SectionFormBody
                                        formData={this.state.content}
                                        reload={this.reload}
                                        load={this.load}
                                        formUpdater={this.formUpdater}
                                        performAction={this.performAction}
                                        reloadSections={this.props.reloadSections}
                                    />
                            )
                            : (
                                <div style={{height: 100, width: "100%", position: "relative"}}>
                                    <Loader/>
                                </div>
                            )
                        }
                    </Section>
                </Display>
                <Display isVisible={this.state.reactComponent !== undefined}>
                    {this.state.reactComponent}
                </Display>
            </>
        );
    }

    private formUpdater = (onUpdate) => {
        this.onFormUpdated = onUpdate;
    }

    private reload = () => {
        this.setState({
            loaded: false,
            content: undefined,
            isChildHTML: false,
        }, () => {
            this.load();
            this.props.onLoaded(null);
        });
    }

    private performAction = (action: string) => {
        this.props.onLoaded(action);
    }

    private load = () => {

        if (EquipmentSettingsService.isReactComponent(this.props.sectionInfo.guid)) {
            this.setState({
                loaded: true,
                reactComponent: getReactComponent(this.props.sectionInfo.guid, this.props.sectionInfo.params)
            });

            return;
        }

        EquipmentSettingsService.getEquipmentSectionContent(this.props.sectionInfo.request)
            .then((result) => {
                if (result.xhr !== undefined && result.xhr.getResponseHeader("content-type").indexOf("html") > -1) {
                    this.setState({
                        isChildHTML: true,
                        content: result.data,
                        loaded: true,
                    }, () => this.props.onLoaded(this.props.sectionInfo.params.htmlContainerID));
                } else {
                    const content = (result as SectionContent).content.reduce((prev, elem) => {
                        return {
                            ...prev,
                            [elem.name]: {
                                ...elem,
                                editing: false,
                            },
                        };
                    }, {});
                    this.setState({
                        content,
                        loaded: true,
                    }, () => {
                        if (this.onFormUpdated) {
                            this.onFormUpdated(this.state.content);
                        }
                    });
                }
            }).catch(console.error);
    }
}

function getReactComponent(componentGuid: string, params: SectionParams) {
    switch (componentGuid) {
        case EQUIPMENT_PRODUCT_STOCK_GUID:
            return (
                <ProductsStockLevel equipmentGuid={params.equipmentGuid} editable={params.editable}/>
            );
        default:
            return null;
    }
}
